import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

const Account = () => import('@/views/Settings/Account.vue');

const myAccount = new Route('/settings/account', 'settings_account', Account, {
  requiresAuth: true,
  isResponsive: flagKeys.responsiveDashboard,
  zendesk: {
    mobile: {
      offsetVertical: '4px',
      offsetHorizontal: '4px'
    }
  },
  navbar: {
    name: 'My Account',
    icon: 'profile'
  },
  pageView: {
    eventLabel: 'My Account'
  }
});

export { myAccount };
export default myAccount;
